// extracted by mini-css-extract-plugin
export default {"deliveryMethod":"CartTotals_deliveryMethod__K7BX3"};